<div class="row border-white-bt m-0">
  <div class="col-2 logo-container d-flex justify-content-center">
    <img
      src="../../../assets/images/logo_itas.png"
      alt="image"
      class="img-fluid p-1 logo-image align-self-center"
    />
  </div>
  <div
    class="col-7 bar-container d-flex align-items-center justify-content-center"
  >
    <p-menubar
      [model]="commission"
      styleClass="menubar"
      [autoDisplay]="false"
    />
    <p-menubar
      [model]="backRecord"
      styleClass="menubar w-120 "
      [autoDisplay]="false"
    />
    <p-menubar
      [model]="plansAccounts"
      styleClass="menubar w-120 "
      [autoDisplay]="false"
    />
    <p-menubar
      [model]="cashControl"
      styleClass="menubar w-120 "
      [autoDisplay]="false"
    />
    <!-- <p-menubar
      [model]="census"
      styleClass="menubar w-120 "
      [autoDisplay]="false"
    /> -->
  </div>

  <div class="col-3 bar-container d-flex align-items-center text-white">
    <div class="d-flex justify-content-center align-items-center">
      <p-image
        src="../../../assets/icons/user_icon.svg"
        alt="Touched SVG"
        width="36"
        class="me-3"
      ></p-image>
      <div class="row">
        <div>
          {{ this.userInfo?.name }} {{ this.userInfo?.surname }} ({{
            this.userInfo?.username?.toUpperCase()
          }})
        </div>
        <div>
          {{ this.userInfo?.agencyDescription }}
        </div>
      </div>
    </div>
    <div class="hidden"></div>
    <div>
      <!-- <i class="pi pi-cog m-2"></i> -->
      <i
        role="button"
        class="pi pi-sign-out m-2"
        (click)="onClickLogout()"
        title="Logout"
      ></i>
    </div>
  </div>
</div>
